import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import color from 'color';

import {Icon, ThemeContext} from '../';

const Modal = ({
  title,
  children,
  size,
  textAlign,
  contentStyles,
  customClasses,
  onClose,
  ...modalProps
}) => {
  const modalClasses = `modal modal_size_${size}`;
  const contentClasses = `modal__content text-${textAlign} ${contentStyles}`;

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const {secondaryColor} = theme;
        const titleStyles = {
          color: secondaryColor,
        };
        const headerStyles = {
          backgroundColor: color(secondaryColor).alpha(0.1).rgbString(),
        };

        return (
          <ReactModal
            {...modalProps}
            onRequestClose={onClose}
            ariaHideApp={false}
            className={{
              base: `${modalClasses} ${customClasses}`,
              afterOpen: 'modal_opened',
              beforeClose: '',
            }}
          >
            <div className="modal__header row row_space-between" style={headerStyles}>
              <span className="modal__close" tabIndex={0} role="button" onClick={onClose}>
                <Icon glyph="close" iconSize="28"/>
              </span>
              {title && <h3 className="modal__title" style={titleStyles}>{title}</h3>}
            </div>
            <div className={contentClasses}>
              {children}
            </div>
          </ReactModal>
        );
      }}
    </ThemeContext.Consumer>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
  onAfterOpen: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  closeTimeoutMS: PropTypes.number,
  style: PropTypes.shape(),
  size: PropTypes.string.isRequired,
  textAlign: PropTypes.string.isRequired,
  contentStyles: PropTypes.string,
  customClasses: PropTypes.string,
};

Modal.defaultProps = {
  title: '',
  children: null,
  onAfterOpen: () => {},
  closeTimeoutMS: 0,
  style: {},
  size: 'auto',
  textAlign: 'left',
  contentStyles: '',
  customClasses: '',
};

export default Modal;
